module.exports = (__webpack_require__(24))(23);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference lib_core
// module id = 475
// module chunks = 109